import React, { useCallback, useEffect, useRef } from 'react'
import ProgressTimeout from '../../../widgets/ProgressTimeout';
import useWebSocketCaller from '../../../../hooks/useWebSocketCaller';
import './KeyTitleDelete.css'

export default function KeyTitleDelete({folderPath, keyName, hideMe}) {  
  const {sendMessage} = useWebSocketCaller();
  const hideTimerRef = useRef(null);

  const confirmDuration = 7000;

  const hideConfirmDelete = useCallback(() => {
    clearTimeout(hideTimerRef.current);
    hideMe();
  }, [hideMe]);

  //---[  Delete Key  ]---
  //
  const deleteKey = useCallback(() => {    
    console.log('Delete key: %s', keyName);
    hideConfirmDelete();
    sendMessage('delete-config-key', {
      basePath: folderPath,
      key: keyName
    })
  }, [folderPath, keyName, hideConfirmDelete, sendMessage]);


  // Effect
  //
  useEffect(()=>{
    hideTimerRef.current = setTimeout(()=>hideConfirmDelete(), confirmDuration);

    return () => {      
      clearTimeout(hideTimerRef.current);
    }
  }, [hideConfirmDelete]);

  return (
    <div className='keyTitleDelete'>
      <div>Delete Key?</div>
      <div className='kdCtrls'>
        <div className='kdCancel'>
          <div className='deleteOptionNo' onClick={hideConfirmDelete}>Cancel</div>
          <ProgressTimeout millis={confirmDuration}/>
        </div>
        <div className='deleteOptionYes' onClick={deleteKey}>Yes, Delete!</div>
      </div>
    </div>
  )
}
